import * as React from 'react'
import {DataObjectId, isDataObjectId} from 'yougile-model'
import {Util} from 'yougile-util'
import {UserAvatarUtils} from '../extensions/user-avatar-utils'

interface Props extends React.HTMLProps<HTMLDivElement> {
  userId: DataObjectId
  userName: string
  email?: string
  avatar?: string
  status?: string
  inDnd?: boolean
  withStatus?: boolean
  size?: number
  isDisallowed?: boolean
  guestId?: string
  opacity?: number
}

// eslint-disable-next-line max-lines-per-function
export const Avatar = ({
  userName,
  userId,
  inDnd,
  email,
  guestId,
  opacity,
  avatar,
  status,
  isDisallowed,
  withStatus,
  size,
  ...rest
}: Props) => {
  const isRegisteredGuest = isDataObjectId(guestId)

  const style = {
    ...(size
      ? {
          width: size + 'px',
          height: size + 'px',
          lineHeight: size + 'px',
          fontSize: Math.ceil(size / 2.2) + 'px'
        }
      : {}),
    background: UserAvatarUtils.avaColorByName(userName, email, opacity)
  }
  const bgColor =
    guestId && !isRegisteredGuest
      ? UserAvatarUtils.avaColorByName(guestId, '')
      : undefined

  const getPhotoBg = () => 'url("' + UserAvatarUtils.preview(avatar) + '")'

  let statusClass =
    'user-avatar-status ' +
    (status === 'online'
      ? 'user-avatar-status-online'
      : 'user-avatar-status-offline')
  if (inDnd) {
    statusClass += ' user-avatar-status-dnd'
  }

  const photo = avatar ? (
    <div
      className="user-avatar-photo"
      style={{backgroundImage: getPhotoBg(), backgroundColor: bgColor}}
    />
  ) : undefined

  const statusView = withStatus ? (
    <div className={statusClass}>
      <div className="user-avatar-status-inner" />
    </div>
  ) : undefined

  const className = Util.className({
    'user-avatar': true,
    [rest.className]: !!rest.className,
    invited: email && userName === '_',
    disallowed: isDisallowed
  })

  return (
    <div
      {...rest}
      className={className}
      style={{...style, ...(rest.style ?? {})}}
    >
      {photo}
      {statusView}
      {UserAvatarUtils.avaShortName(userName, {id: userId, email})}
    </div>
  )
}
